export default () => (subject, message) => {
    navigator.clipboard.writeText(subject)

    notify('success', message)
}
